import { Col, Row, Text } from 'components';

const SubscriptionsList = ({}) => {
  return (
    <Col wid="100%" ht="100vh" centerAll>
      <Row center>
        <Text h4>This feature is coming soon!</Text>
      </Row>
    </Col>
  );
};

export default SubscriptionsList;
